import { render, staticRenderFns } from "./EditDepartment.vue?vue&type=template&id=9699c274&"
import script from "./EditDepartment.vue?vue&type=script&lang=ts&"
export * from "./EditDepartment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports